__turbopack_context__.v({
  "button": "HiOs8W_button",
  "danger": "HiOs8W_danger",
  "navLink": "HiOs8W_navLink",
  "navLinkActive": "HiOs8W_navLinkActive",
  "onColorful": "HiOs8W_onColorful",
  "primary": "HiOs8W_primary",
  "primaryVariant": "HiOs8W_primaryVariant",
  "pro": "HiOs8W_pro",
  "secondary": "HiOs8W_secondary",
  "secondaryVariant": "HiOs8W_secondaryVariant",
  "tertiary": "HiOs8W_tertiary",
  "tertiaryVariant": "HiOs8W_tertiaryVariant",
});
